import React from "react";
import siteLogo from "@/assets/images/logo/logo.svg";

interface SiteLogoProps {
    size?: "smallHeader" | "header" | "small" | "medium" | "large";
}

const SiteLogo: React.FC<SiteLogoProps> = ({ size = "header" }) => {
    const sizeMap = {
        smallHeader: 260,
        header: 125,
        small: 150,
        medium: 200,
        large: 250,
    };

    const width = sizeMap[size || "small"];

    return (
        <div>
            <img
                src={siteLogo}
                alt="Güneş Gaz Logo"
                style={{ width: `${width}px`, height: "auto", marginTop: "-30px" }}
            />
        </div >
    )
}

export default SiteLogo;